import { localizeWithPath, localize2WithPath } from '../../../../nls.js';
import '../../../../platform/actions/common/actions.js';
import { RawContextKey } from '../../../../platform/contextkey/common/contextkey.js';
import { URI } from '../../../../base/common/uri.js';
import { registerIcon } from '../../../../platform/theme/common/iconRegistry.js';
import { Codicon } from '../../../../base/common/codicons.js';
const _moduleId = "vs/workbench/services/userDataProfile/common/userDataProfile";
const PROFILE_URL_AUTHORITY = 'profile';
function toUserDataProfileUri(path, productService) {
    return (
         (URI.from({
            scheme: productService.urlProtocol,
            authority: PROFILE_URL_AUTHORITY,
            path: path.startsWith('/') ? path : `/${path}`
        }))
    );
}
const defaultUserDataProfileIcon = registerIcon('defaultProfile-icon', Codicon.settings, ( localizeWithPath(_moduleId, 0, 'Icon for Default Profile.')));
const PROFILES_TITLE = ( localize2WithPath(_moduleId, 1, 'Profiles'));
const PROFILES_CATEGORY = { ...PROFILES_TITLE };
const PROFILE_EXTENSION = 'code-profile';
const PROFILE_FILTER = [{ name: ( localizeWithPath(_moduleId, 2, "Profile")), extensions: [PROFILE_EXTENSION] }];
const CURRENT_PROFILE_CONTEXT = ( (new RawContextKey('currentProfile', '')));
const IS_PROFILE_EXPORT_IN_PROGRESS_CONTEXT = ( (new RawContextKey('isProfileExportInProgress', false)));
const IS_PROFILE_IMPORT_IN_PROGRESS_CONTEXT = ( (new RawContextKey('isProfileImportInProgress', false)));
export { CURRENT_PROFILE_CONTEXT, IS_PROFILE_EXPORT_IN_PROGRESS_CONTEXT, IS_PROFILE_IMPORT_IN_PROGRESS_CONTEXT, PROFILES_CATEGORY, PROFILES_TITLE, PROFILE_EXTENSION, PROFILE_FILTER, PROFILE_URL_AUTHORITY, defaultUserDataProfileIcon, toUserDataProfileUri };
